<template>
  <div class="pdf-wraper">
    <div id="pdf-ui" class="viewer-container"></div>
    <uploader
      ref="uploader"
      :options="options"
      :autoStart="false"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      ><div></div
    ></uploader>
  </div>
</template>
<script>
import {
  fileOrFolderInfo,
  getFileUploadUrl,
  fileEditComplete,
  fileComplete,
} from "@/api/drive/drive";
import "@/assets/foxit/adaptive.js";
import "@/assets/foxit/preload-jr-worker.js";
import "@/assets/foxit/UIExtension.full.js";

import { info } from "@/api/common/index";
import { config } from "@/config/index";
import { getToken, getStorage } from "@/utils/auth";
import xml2js from "xml2js";
let uploader2 = null;

export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    dialogStatus: {
      type: String,
      default: "view",
    },
    detail: {
      type: Object,
    },
    app_save_folder_number: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isDocModified: false, // 文件是否被编辑过
      force_cover: 0, // 编辑文件是否强制覆盖：0否1是
      options: {
        allowDuplicateUploads: true, // 允许再次上传
        removeChunkLink: config.api + "/file/swift/batch/delete",
        // target: "//localhost:3000/upload", // 目标上传 URL
        target: [], // 目标上传 URL
        uploadMethod: "post", //默认为post，根据返回参数修改
        chunkSize: 10485760, //分块大小
        fileParameterName: "file0", //上传文件时文件的参数名，默认file
        maxChunkRetries: 10, //最大自动失败重试上传次数
        chunkRetryInterval: 3000, //重试间隔
        testChunks: false, //是否开启服务器分片校验
        simultaneousUploads: 1,
        forceChunkSize: true, //强制所有的块都是小于等于 chunkSize
        permanentErrors: [403],
        parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
          return (
            "剩余" +
            parsedTimeRemaining
              .replace(/\syears?/, "年")
              .replace(/\days?/, "天")
              .replace(/\shours?/, "小时")
              .replace(/\sminutes?/, "分钟")
              .replace(/\sseconds?/, "秒")
          );
        },
        headers: {
          // 在header中添加的验证，请根据实际业务来
          "X-auth-token": getToken(),
        },
      },
    };
  },
  computed: {
    templateStatus() {
      return this.dialogStatus === "view" ? "preview" : "edit";
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
  },
  methods: {
    uploadPdf() {
      this.pdfui
        .getPDFViewer()
        .then((pdfViewer) => {
          const buffers = [];
          return pdfViewer.currentPDFDoc
            .getStream(({ arrayBuffer }) => {
              buffers.push(arrayBuffer);
            })
            .then(() => {
              return [buffers];
            });
        })
        .then(([buffers]) => {
          const file = new File(
            buffers,
            this.detail.name + "." + this.detail.file_ext,
            {
              type: "application/pdf",
            }
          );
          uploader2.addFile(file);
        });
    },
    // 配置系统分片大小
    initOptsChunkSize() {
      info()
        .then((res) => {
          if (res.status_code === 200) {
            uploader2.opts.chunkSize = res.entity.chunk_size;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    onFileError(rootFile, file, message, chunk) {
      const parser = new xml2js.Parser();
      parser.parseString(message, (err, result) => {
        let msg = "";
        if ("AccessDenied" === result.Error.Code[0]) {
          msg = "上传失败，失败原因：" + result.Error.Code[0];
        } else {
          msg = "上传失败，失败原因：" + result.Error.Code[0];
        }
        this.$message({
          type: "success",
          message: msg,
        });
      });
    },
    async onFileAdded(file) {
      await this.initOptsChunkSize();
      // 获取所在文件夹number
      const parent_number = this.detail.number
        ? await fileOrFolderInfo({
            number: this.detail.number,
            type: "file",
            is_path: false,
            group_number: this.groupNumber,
          }).then((res) => {
            if (res.status_code === 200) {
              return res.entity.parent_number;
            }
          })
        : this.app_save_folder_number;
      console.log(parent_number);
      let storage = getStorage();
      // 申请上传地址
      await getFileUploadUrl({
        storage: storage ? storage : "",
        number: parent_number,
        file_name: file.name,
        byte: file.size,
        disk_type: "cloud",
        group_number: this.groupNumber,
        version: this.detail.version,
        force_cover: this.force_cover,
        file_number: this.dialogStatus === "edit" ? this.detail.number : 0,
      })
        .then((res) => {
          if (res.status_code === 200) {
            file.storage = storage;
            file.target = [];
            file.query = [];
            file.chunkSize = res.entity.upload_chunk_size;
            file.upload_token = res.entity.upload_token;
            let upload_params = res.entity.upload_params;
            if (storage === "moss") {
              upload_params.map(function (param) {
                file.target.push(param[1].value);
                file.query.push({
                  chunkUploadMethod: param[2].value,
                });
              });
            } else {
              upload_params.map(function (param) {
                file.target.push(param[0].value);
                file.query.push({
                  max_file_count: param[1].value,
                  max_file_size: param[2].value,
                  expires: param[3].value,
                  signature: param[4].value,
                  chunkUploadMethod: param[6].value,
                });
              });
            }
            file.resume();
          } else if (res.status_code === 5010) {
            this.$emit("toggleUploading", false);
            file.cancel();
            this.$confirm({
              type: "confirm",
              showCancleBtn: false,
              showYesBtn: false,
              content: res.message,
              custom: [
                {
                  action: "add",
                  btnText: "新增",
                },
                {
                  action: "cover",
                  btnText: "覆盖",
                },
              ],
            })
              .then((action) => {
                if (action === "add") {
                  this.$message({
                    type: "success",
                    message: "正在新增上传...",
                  });
                  this.force_cover = 0;
                  this.$emit("updateEditToCreateStatus", "create");
                  this.$emit("saveFile");
                } else if (action === "cover") {
                  this.$emit("changeVersion", res.entity.version);
                  this.$message({
                    type: "success",
                    message: "正在覆盖上传...",
                  });
                  this.force_cover = 1;
                  this.$emit("saveFile");
                }
              })
              .catch(() => {});
          } else {
            this.$emit("toggleUploading", false);
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$emit("toggleUploading", false);
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    onFileSuccess(rootFile, file, response, chunk) {
      if (this.dialogStatus === "create") {
        this.fileComplete(file);
      } else {
        this.fileEditComplete(file);
      }
    },
    fileEditComplete(file) {
      console.log(this.detail);
      fileEditComplete({
        file_id: this.detail.number,
        upload_token: file.upload_token,
        group_number: this.groupNumber,
        version: this.detail.version,
        force_cover: this.force_cover,
      })
        .then((res) => {
          this.$emit("toggleUploading", false);
          if (res.status_code === 200) {
            this.force_cover = 0;
            this.$emit("changeVersion", res.entity.version);
            this.$message({
              type: "success",
              message: res.message,
            });
          } else if (res.status_code === 5010) {
            this.$confirm({
              type: "confirm",
              showCancleBtn: false,
              showYesBtn: false,
              content: res.message,
              custom: [
                {
                  action: "add",
                  btnText: "新增",
                },
                {
                  action: "cover",
                  btnText: "覆盖",
                },
              ],
            })
              .then((action) => {
                if (action === "add") {
                  this.$message({
                    type: "success",
                    message: "正在新增上传...",
                  });
                  this.force_cover = 0;
                  this.$emit("updateEditToCreateStatus", "create");
                  this.$emit("saveFile");
                } else if (action === "cover") {
                  this.$emit("changeVersion", res.entity.version);
                  this.$message({
                    type: "success",
                    message: "正在覆盖上传...",
                  });
                  this.force_cover = 1;
                  this.$emit("saveFile");
                }
              })
              .catch(() => {});
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$emit("toggleUploading", false);
          this.$message({
            type: "error",
            message: err,
          });
        })
        .finally(() => {
          this.$emit("toggleUploading", false);
        });
    },
    fileComplete(file) {
      fileComplete({
        upload_token: file.upload_token,
      })
        .then((res) => {
          this.$emit("toggleUploading", false);
          if (res.status_code === 200) {
            this.$emit("changeVersion", res.entity.version);
            this.$message({
              type: "success",
              message: res.message,
            });
            if (this.dialogStatus === "create") {
              this.$emit("updateCreateToEditStatus", {
                number: res.entity.number,
                name: res.entity.name,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$emit("toggleUploading", false);
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    uploader2 = this.$refs.uploader.uploader;
    const licenseSN = process.env.VUE_APP_FOXIT_LICENSE_SN;
    const licenseKey = process.env.VUE_APP_FOXIT_LICENSE_KEY;
    // const license = process.env.VUE_APP_FOXIT_LICENSE;
    const readyWorker = preloadJrWorker({
      workerPath: config.url + "/foxit-lib/",
      enginePath: config.url + "/foxit-lib/jr-engine/gsdk",
      fontPath: config.url + "/external/brotli",
      licenseSN: licenseSN,
      licenseKey: licenseKey,
      // l: license,
    });
    fetch(
      UIExtension.PDFViewCtrl.DeviceInfo.isMobile
        ? `${config.url}/foxit-lib/built-in-mobile-layout-template-${this.templateStatus}.tpl`
        : `${config.url}/foxit-lib/built-in-pc-layout-template-${this.templateStatus}.tpl`
    )
      .then(function (response) {
        return response.text();
      })
      .then((template) => {
        // const Events = UIExtension.PDFViewCtrl.Events;
        this.pdfui = window.pdfui = new UIExtension.PDFUI({
          i18n: {
            absolutePath: config.url + "/foxit-lib/locales",
            lng: "zh-CN",
            // lng: "en-US",
          },
          viewerOptions: {
            libPath: config.url + "/foxit-lib",
            defaultViewMode: "continuous-view-mode", // 设置默认显示模式
            defaultScale: "fitPage", // 设置默认的缩放比例
            jr: {
              readyWorker: readyWorker,
              licenseSN: licenseSN,
              licenseKey: licenseKey,
            },
          },
          renderTo: "#pdf-ui",
          appearance: UIExtension.appearances.adaptive,
          template: template,
          // template: `<webpdf><viewer></viewer></webpdf>`,
          fragments: this.dialogStatus === "view" ? [] : [],
          addons: [
            config.url + "/foxit-lib/uix-addons/file-property",
            config.url + "/foxit-lib/uix-addons/multi-media",
            config.url + "/foxit-lib/uix-addons/password-protect",
            config.url + "/foxit-lib/uix-addons/redaction",
            config.url + "/foxit-lib/uix-addons/path-objects",
            config.url + "/foxit-lib/uix-addons/print",
            config.url + "/foxit-lib/uix-addons/full-screen",
            config.url + "/foxit-lib/uix-addons/import-form",
            config.url + "/foxit-lib/uix-addons/export-form",
            config.url + "/foxit-lib/uix-addons/undo-redo",
            config.url + "/foxit-lib/uix-addons/thumbnail",
            config.url + "/foxit-lib/uix-addons/h-continuous",
          ].concat(
            UIExtension.PDFViewCtrl.DeviceInfo.isMobile
              ? []
              : [
                  config.url + "/foxit-lib/uix-addons/text-object",
                  config.url + "/foxit-lib/uix-addons/form-designer",
                  config.url + "/foxit-lib/uix-addons/recognition-form",
                ]
          ),
        });

        if (this.dialogStatus != "create") {
          // 加载文件
          fetch(this.url).then((response) => {
            response
              .arrayBuffer()
              .then((buffer) => {
                this.pdfui.openPDFByFile(buffer);
              })
              .then(() => {
                // console.log("pdf 100% 显示1");
                // console.log(this.pdfui);
                // this.pdfui.pdfViewer.zoomTo('fitWidth');
              });
          });
        } else {
          // 创建空白页
          this.pdfui
            .getPDFViewer()
            .then((pdfViewer) => {
              pdfViewer.createNewDoc().then((pdfDoc) => {
                // pdfDoc.insertPage(0, 595, 842);
                pdfDoc.insertPage(1);
              });
            })
            .catch(function (err) {
              console.log(err);
            });
        }

        window.addEventListener(
          UIExtension.PDFViewCtrl.DeviceInfo.isDesktop
            ? "resize"
            : "orientationchange",
          function (e) {
            this.pdfui.redraw().catch(function (err) {
              console.log(err);
            });
          }
        );
        this.pdfui.addUIEventListener(
          "fullscreenchange",
          function (isFullscreen) {
            if (isFullscreen) {
              document.body.classList.add("fv__pdfui-fullscreen-mode");
            } else {
              document.body.classList.remove("fv__pdfui-fullscreen-mode");
            }
          }
        );
        // 下方的代码仅在打开本地/URL文件时适用，如无需打开文件，下面代码可删除
        // function openLoadingLayer() {
        //   return window.pdfui.loading();
        // }
        // const loadingComponentPromise = openLoadingLayer();

        // window.pdfui.addViewerEventListener(Events.beforeOpenFile, function () {
        //   if (loadingComponentPromise) {
        //     loadingComponentPromise = loadingComponentPromise
        //       .then(function (component) {
        //         component.close();
        //       })
        //       .then(openLoadingLayer);
        //   } else {
        //     loadingComponentPromise = openLoadingLayer();
        //   }
        // });
        // window.pdfui.addViewerEventListener(
        //   Events.openFileSuccess,
        //   function () {
        //     loadingComponentPromise.then(function (component) {
        //       component.close();
        //     });
        //   }
        // );
        // window.pdfui.addViewerEventListener(Events.openFileFailed, function () {
        //   loadingComponentPromise.then(function (component) {
        //     component.close();
        //   });
        // });
      });
  },
};
</script>
<style scoped>
@import "../../../assets/foxit/UIExtension.css";
@import "../../../assets/foxit/index.css";
</style>
